import { language } from '../utils/language';
import convertArrToObj from '../utils/convertArrToObj';

export const DEAL_METHOD_CASH = 'CASH';
export const DEAL_METHOD_TRANSFER = 'TRANSFER';
export const DEAL_METHOD_ONLINE = 'ONLINE';

export const DEAL_METHOD_OPTION = [
  {
    value: DEAL_METHOD_CASH,
    label: language.cash,
  },
  {
    value: DEAL_METHOD_TRANSFER,
    label: language.transfer,
  },
  {
    value: DEAL_METHOD_ONLINE,
    label: language.online,
  },
];

export const DEAL_METHOD_OBJ = convertArrToObj(DEAL_METHOD_OPTION, 'value');

export const FUND_PAYMENT_MODE_ON = 'ON'; // Sẵn sàng có thể thanh toán
export const FUND_PAYMENT_MODE_VIEW = 'VIEW'; // Chỉ hiển thị dạng disabled
export const FUND_PAYMENT_MODE_OFF = 'OFF'; // Ẩn thanh toán

export const FUND_PAYMENT_MODES = [
  { value: FUND_PAYMENT_MODE_ON, label: language.on },
  { value: FUND_PAYMENT_MODE_VIEW, label: language.view },
  { value: FUND_PAYMENT_MODE_OFF, label: language.off },
];

export const DEAL_METHOD_BY_ID = convertArrToObj(DEAL_METHOD_OPTION);

export const ONLINE_ACCOUNT_OPTION = [
  {
    id: 1,
    code: 'VNPAY_QR',
    name: language.vnpay_qr,
    fundName: 'Quét mã VNPAY-QR',
    domestic: true,
  },
  {
    id: 2,
    code: 'MOMO_IN_APP',
    name: language.momo,
    fundName: 'Ví MoMo',
    domestic: true,
  },
  {
    id: 3,
    code: 'VNPAY_GW',
    name: language.vnpay_gw_domestic,
    fundName: 'ATM nội địa và tài khoản ngân hàng',
    domestic: true,
  },
  // {
  //   id: 4,
  //   code: 'VNPAY_GW',
  //   name: language.vnpay_gw_international,
  //   fundName: 'Thẻ thanh toán quốc tế (Visa, Mastercard)',
  //   domestic: false,
  // },
  {
    id: 5,
    code: 'CYHOME_MB_APP',
    name: language.vnpay_mb_app,
    fundName: 'Thanh toán qua ứng dụng ngân hàng',
    domestic: true,
  },
  {
    id: 6,
    code: 'SHOPEEPAY_IN_APP',
    name: language.shopee_app,
    fundName: 'Thanh toán qua ứng dụng shopee',
    domestic: true,
  },
];

export const ONLINE_ACCOUNT_OBJ = convertArrToObj(ONLINE_ACCOUNT_OPTION, 'code');
